module.exports = __webpack_public_path__ + "static/media/4.21c9a1a0.png";